<div class="np-form-control dx-fieldset">
    <dx-box direction="row" width="100%" [ngStyle]="{ gap: '2rem' }">
        <dxi-item [ratio]="1">
            <div class="np-scireum-col-stack">
                <div class="dx-card">
                    <div class="dx-fieldset">

                        <div class="dx-fieldset-header ">{{ 'Artikelinformationen' | translate }}</div>

                        <div class="np-scireum-grid-2col">
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Neu' | translate }}"
                                                 [field]="fieldNames.scireumIsNew"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.isNew"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumIsNew"
                                                              [readOnly]="readOnly(fieldNames.scireumIsNew)"
                                                              (onValueChanged)="update($event, fieldNames.scireumIsNew)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Aktion' | translate }}"
                                                 [field]="fieldNames.scireumSale"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.sale"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumSale"
                                                              [readOnly]="readOnly(fieldNames.scireumSale)"
                                                              (onValueChanged)="update($event, fieldNames.scireumSale)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Abverkauf' | translate }}"
                                                 [field]="fieldNames.scireumClearance"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.clearance"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumClearance"
                                                              [readOnly]="readOnly(fieldNames.scireumClearance)"
                                                              (onValueChanged)="update($event, fieldNames.scireumClearance)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Nicht bestellbar' | translate }}"
                                                 [field]="fieldNames.scireumIsNotOrderable"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.isNotOrderable"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumIsNotOrderable"
                                                              [readOnly]="readOnly(fieldNames.scireumIsNotOrderable)"
                                                              (onValueChanged)="update($event, fieldNames.scireumIsNotOrderable)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Versteckt' | translate }}"
                                                 [field]="fieldNames.scireumHidden"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.hidden"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumHidden"
                                                              [readOnly]="readOnly(fieldNames.scireumHidden)"
                                                              (onValueChanged)="update($event, fieldNames.scireumHidden)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Lagerartikel' | translate }}"
                                                 [field]="fieldNames.scireumStockItem"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.stockItem"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumStockItem"
                                                              [readOnly]="readOnly(fieldNames.scireumStockItem)"
                                                              (onValueChanged)="update($event, fieldNames.scireumStockItem)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field" *ngIf="loginService.hasAddonSellsite_Bormann">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Exportfähig' | translate }}"
                                                 [field]="fieldNames.scireumExportable"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.exportable"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumExportable"
                                                              [readOnly]="readOnly(fieldNames.scireumExportable)"
                                                              (onValueChanged)="update($event, fieldNames.scireumExportable)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Fachhandelsbindung' | translate }}"
                                                 [field]="fieldNames.scireumSpecialistRetailer"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.specialistRetailer"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumSpecialistRetailer"
                                                              [readOnly]="readOnly(fieldNames.scireumSpecialistRetailer)"
                                                              (onValueChanged)="update($event, fieldNames.scireumSpecialistRetailer)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Serie' | translate }}"
                                             [field]="fieldNames.scireumSeries"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.series"
                                                 width="80%"
                                                 placeholder="Comfort-Line"
                                                 (onValueChanged)="update($event, fieldNames.scireumSeries)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">

                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumSeries)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field" *ngIf="loginService.hasAddonSellsite_Bormann">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Zusätzlicher erweiterter Suchbegriff' | translate }}"
                                             [field]="fieldNames.scireumExtendedKeyword"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.extendedKeyword"
                                                 width="80%"
                                                 (onValueChanged)="update($event, fieldNames.scireumExtendedKeyword)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumExtendedKeyword)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Konfigurator URL' | translate }}"
                                             [field]="fieldNames.scireumConfiguratorLink"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.configuratorLink"
                                                 width="80%"
                                                 placeholder="https://..."
                                                 (onValueChanged)="update($event, fieldNames.scireumConfiguratorLink)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumConfiguratorLink)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Ranking' | translate }}"
                                             [field]="fieldNames.scireumRanking"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-number-box [(value)]="model.scireum.ranking"
                                                   [min]="0"
                                                   width="40%"
                                                   placeholder=""
                                                   (onValueChanged)="update($event, fieldNames.scireumRanking)"
                                                   [showSpinButtons]="true">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumRanking)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-number-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
                </div>

                <!--Zusätzliche Logistikmaße & Einheiten -->

                <div class="dx-card">
                    <div class="dx-fieldset">
                        <div class="dx-fieldset-header">{{ 'Zusätzliche Logistikmaße & Einheiten' | translate }}</div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Empfohlene Menge' | translate }}"
                                             [field]="fieldNames.scireumEmpfohleneMenge"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-number-box [(value)]="model.scireum.empfohleneMenge"
                                                   [min]="0"
                                                   width="40%"
                                                   placeholder=""
                                                   (onValueChanged)="update($event, fieldNames.scireumEmpfohleneMenge)"
                                                   [showSpinButtons]="true">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumEmpfohleneMenge)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-number-box>
                                </div>
                            </np-inputControl>

                        </div>

                        <div class="np-scireum-subheader">{{ 'Artikelmaße in mm' | translate }}</div>
                        <div class="np-scireum-grid-4col">
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Länge' | translate }}"
                                                 [field]="fieldNames.scireumArtikellaengeMM"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-number-box [(value)]="model.scireum.artikellaengeMM"
                                                       [min]="0"
                                                       placeholder=""
                                                       (onValueChanged)="update($event, fieldNames.scireumArtikellaengeMM)">
                                            <dx-validator validationGroup="SCIREUM"
                                                          (onInitialized)="validationService.startAutomaticValidation($event)">
                                                <dxi-validation-rule type="async"
                                                                     [validationCallback]="validationService.validateField(fieldNames.scireumArtikellaengeMM)"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Breite' | translate }}"
                                                 [field]="fieldNames.scireumArtikelbreiteMM"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-number-box [(value)]="model.scireum.artikelbreiteMM"
                                                       placeholder=""
                                                       (onValueChanged)="update($event, fieldNames.scireumArtikelbreiteMM)">
                                            <dx-validator validationGroup="SCIREUM"
                                                          (onInitialized)="validationService.startAutomaticValidation($event)">
                                                <dxi-validation-rule type="async"
                                                                     [validationCallback]="validationService.validateField(fieldNames.scireumArtikelbreiteMM)"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Höhe' | translate }}"
                                                 [field]="fieldNames.scireumArtikelhoeheMM"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-number-box [(value)]="model.scireum.artikelhoeheMM"
                                                       [min]="0"
                                                       placeholder=""
                                                       (onValueChanged)="update($event, fieldNames.scireumArtikelhoeheMM)">
                                            <dx-validator validationGroup="SCIREUM"
                                                          (onInitialized)="validationService.startAutomaticValidation($event)">
                                                <dxi-validation-rule type="async"
                                                                     [validationCallback]="validationService.validateField(fieldNames.scireumArtikelhoeheMM)"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Tiefe' | translate }}"
                                                 [field]="fieldNames.scireumArtikeltiefeMM"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-number-box [(value)]="model.scireum.artikeltiefeMM"
                                                       [min]="0"
                                                       placeholder=""
                                                       (onValueChanged)="update($event, fieldNames.scireumArtikeltiefeMM)">
                                            <dx-validator validationGroup="SCIREUM"
                                                          (onInitialized)="validationService.startAutomaticValidation($event)">
                                                <dxi-validation-rule type="async"
                                                                     [validationCallback]="validationService.validateField(fieldNames.scireumArtikeltiefeMM)"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>

                        <div class="np-scireum-subheader">{{ 'Gewicht & Volumen' | translate }}</div>
                        <div class="np-scireum-grid-2col">
                            <div class="np-field">

                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Gewicht in kg' | translate }}"
                                                 [field]="fieldNames.scireumArtikelGewichtKG"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-number-box [(value)]="model.scireum.artikelGewichtKG"
                                                       [min]="0"
                                                       placeholder=""
                                                       (onValueChanged)="update($event, fieldNames.scireumArtikelGewichtKG)">
                                            <dx-validator validationGroup="SCIREUM"
                                                          (onInitialized)="validationService.startAutomaticValidation($event)">
                                                <dxi-validation-rule type="async"
                                                                     [validationCallback]="validationService.validateField(fieldNames.scireumArtikelGewichtKG)"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Volumen in m³' | translate }}"
                                                 [field]="fieldNames.scireumVolumen"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <dx-number-box [(value)]="model.scireum.volumen"
                                                       [min]="0"
                                                       placeholder=""
                                                       (onValueChanged)="update($event, fieldNames.scireumVolumen)">
                                            <dx-validator validationGroup="SCIREUM"
                                                          (onInitialized)="validationService.startAutomaticValidation($event)">
                                                <dxi-validation-rule type="async"
                                                                     [validationCallback]="validationService.validateField(fieldNames.scireumVolumen)"></dxi-validation-rule>
                                            </dx-validator>
                                        </dx-number-box>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Warennummer' | translate }}"
                                             [field]="fieldNames.scireumWarennummer"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.warennummer"
                                                 width="40%"
                                                 placeholder="z.B. 8433 0815"
                                                 (onValueChanged)="update($event, fieldNames.scireumWarennummer)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumWarennummer)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
                </div>



                <!-- Zusätzliche Aritkelnummern-->
                <div class="dx-card">
                    <div class="dx-fieldset">
                        <div class="dx-fieldset-header">{{ 'Zusätzliche Artikelnummern' | translate }}</div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'OXOMI Hausmarkennummer' | translate }}"
                                             [field]="fieldNames.scireumOxomiHausmarkennummer"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.oxomiHausmarkennummer"
                                                 width="40%"
                                                 (onValueChanged)="update($event, fieldNames.scireumOxomiHausmarkennummer)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumOxomiHausmarkennummer)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field" *ngIf="loginService.hasAddonSellsite_Bormann">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Nordwest-Artikelnummer' | translate }}"
                                             [field]="fieldNames.scireumNordwestArtikelnummer"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.nordwestArtikelnummer"
                                                 width="40%"
                                                 (onValueChanged)="update($event, fieldNames.scireumNordwestArtikelnummer)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumNordwestArtikelnummer)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Abweichende Lieferantennummer' | translate }}"
                                             [field]="fieldNames.scireumAbweichendeLieferantennummer"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.abweichendeLieferantennummer"
                                                 width="40%"
                                                 (onValueChanged)="update($event, fieldNames.scireumAbweichendeLieferantennummer)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumAbweichendeLieferantennummer)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Zusätzlicher Match-Code' | translate }}"
                                             [field]="fieldNames.scireumZusaetzlicherMatchCode"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.zusaetzlicherMatchCode"
                                                 width="40%"
                                                 (onValueChanged)="update($event, fieldNames.scireumZusaetzlicherMatchCode)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumZusaetzlicherMatchCode)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Katalogartikelnummer' | translate }}"
                                             [field]="fieldNames.scireumKatalogartikelnummer"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-text-box [(value)]="model.scireum.katalogartikelnummer"
                                                 width="40%"
                                                 (onValueChanged)="update($event, fieldNames.scireumKatalogartikelnummer)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumKatalogartikelnummer)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
                </div>
            </div>
        </dxi-item>

        <dxi-item [ratio]="1">
            <div class="np-scireum-col-stack">
                <!-- Erweiterte Gefahrgutinformationen -->
                <div class="dx-card">
                    <div class="dx-fieldset">
                        <div class="dx-fieldset-header">{{ 'Erweiterte Gefahrgutinformationen' | translate }}</div>

                        <div class="np-scireum-grid-2col">
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Nur gewerblich' | translate }}"
                                                 [field]="fieldNames.scireumNurGewerblich"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.nurGewerblich"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumNurGewerblich"
                                                              [readOnly]="readOnly(fieldNames.scireumNurGewerblich)"
                                                              (onValueChanged)="update($event, fieldNames.scireumNurGewerblich)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Enthält Lithiumbatterie?' | translate }}"
                                                 [field]="fieldNames.scireumLithiumbatterieEnthalten"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.lithiumbatterieEnthalten"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumLithiumbatterieEnthalten"
                                                              [readOnly]="readOnly(fieldNames.scireumLithiumbatterieEnthalten)"
                                                              (onValueChanged)="update($event, fieldNames.scireumLithiumbatterieEnthalten)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Enthält elektrische Komponenten' | translate }}"
                                                 [field]="fieldNames.scireumElektrischeKomponenten"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.enthaeltElektrischeKomponenten"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumElektrischeKomponenten"
                                                              [readOnly]="readOnly(fieldNames.scireumElektrischeKomponenten)"
                                                              (onValueChanged)="update($event, fieldNames.scireumElektrischeKomponenten)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Hat CE-Kennzeichnung' | translate }}"
                                                 [field]="fieldNames.scireumCEKennzeichung"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.ceKennzeichnung"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumCEKennzeichung"
                                                              [readOnly]="readOnly(fieldNames.scireumCEKennzeichung)"
                                                              (onValueChanged)="update($event, fieldNames.scireumCEKennzeichung)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'In ECHA DB hinterlegt' | translate }}"
                                                 [field]="fieldNames.scireumECHABDhinterlegt"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.echadbhinterlegt"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumECHABDhinterlegt"
                                                              [readOnly]="readOnly(fieldNames.scireumECHABDhinterlegt)"
                                                              (onValueChanged)="update($event, fieldNames.scireumECHABDhinterlegt)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                            <div class="np-field">
                                <np-inputControl [(model)]="model"
                                                 [showLinkButtons]="true"
                                                 [suppressPlaceLabel]="true"
                                                 [(selectedElements)]="selectedElements"
                                                 (elementSelected)="elementSelectFunction($event)"
                                                 (onValueChanged)="update($event)"
                                                 labelText="{{ 'Erfüllt Anforderungen der UBA Positivliste' | translate }}"
                                                 [field]="fieldNames.scireumUBAListKonform"
                                                 [showDragHandle]="showDragHandle"
                                                 [dragFilter]="dragFilter"
                                                 (excelElementDropped)="excelElementDrop($event)">
                                    <div slot="content" class="contentSlot">
                                        <np-booleanRadioGroup [(value)]="model.scireum.ubaListKonform"
                                                              [templateView]="templateView"
                                                              [fieldName]="fieldNames.scireumUBAListKonform"
                                                              [readOnly]="readOnly(fieldNames.scireumUBAListKonform)"
                                                              (onValueChanged)="update($event, fieldNames.scireumUBAListKonform)"
                                                              validatorValidationGroup="SCIREUM">
                                        </np-booleanRadioGroup>
                                    </div>
                                </np-inputControl>
                            </div>
                        </div>

                        <div class="np-field">

                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Gefahrgutklasse' | translate }}"
                                             [field]="fieldNames.scireumGefahrengutklasse"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-autocomplete [minSearchLength]="0"
                                                     width="40%"
                                                     [dataSource]="gefahrgutKlassenArray"
                                                     [readOnly]="readOnlyForLinkedFields(fieldNames.scireumGefahrengutklasse)"
                                                     [showClearButton]="showClearButton()"
                                                     [showDropDownButton]="true"
                                                     [(value)]="model.scireum.gefahrengutKlasse"
                                                     (onValueChanged)="update($event, fieldNames.scireumGefahrengutklasse)">

                                    </dx-autocomplete>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Beförderungskategorie' | translate }}"
                                             [field]="fieldNames.scireumBefoerderungskategorie"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-autocomplete [minSearchLength]="0"
                                                     width="40%"
                                                     [dataSource]="befoerderungskategorieArray"
                                                     [readOnly]="readOnlyForLinkedFields(fieldNames.scireumBefoerderungskategorie)"
                                                     [showClearButton]="showClearButton()"
                                                     [showDropDownButton]="true"
                                                     [(value)]="model.scireum.befoerderungskategorie"
                                                     (onValueChanged)="update($event, fieldNames.scireumBefoerderungskategorie)">

                                    </dx-autocomplete>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'UN-Nummer' | translate }}"
                                             [field]="fieldNames.scireumUnNummer"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-number-box [(value)]="model.scireum.unNummer"
                                                   [min]="0"
                                                   width="30%"
                                                   placeholder="UN 0000"
                                                   (onValueChanged)="update($event, fieldNames.scireumUnNummer)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumUnNummer)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-number-box>

                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">

                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Offizielle Bezeichnung' | translate }}"
                                             [field]="fieldNames.scireumOffizielleBezeichnung"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-text-box [(value)]="model.scireum.offizielleBezeichnung"
                                                 width="80%"
                                                 (onValueChanged)="update($event, fieldNames.scireumOffizielleBezeichnung)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumOffizielleBezeichnung)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Technische Bezeichnung' | translate }}"
                                             [field]="fieldNames.scireumTechnischeBezeichnung"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-text-box [(value)]="model.scireum.technischeBezeichnung"
                                                 width="80%"
                                                 (onValueChanged)="update($event, fieldNames.scireumTechnischeBezeichnung)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumTechnischeBezeichnung)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Versandbezeichnung' | translate }}"
                                             [field]="fieldNames.scireumVersandbezeichnung"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-text-box [(value)]="model.scireum.versandbezeichnung"
                                                 width="80%"
                                                 (onValueChanged)="update($event, fieldNames.scireumVersandbezeichnung)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumVersandbezeichnung)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Gefahrenzettel' | translate }}"
                                             [field]="fieldNames.scireumGefahrenzettel"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-autocomplete [minSearchLength]="0"
                                                     width="50%"
                                                     [dataSource]="gefahrenzettelArray"
                                                     [readOnly]="readOnlyForLinkedFields(fieldNames.scireumGefahrenzettel)"
                                                     [showClearButton]="showClearButton()"
                                                     [showDropDownButton]="true"
                                                     [(value)]="model.scireum.gefahrenzettel"
                                                     (onValueChanged)="update($event, fieldNames.scireumGefahrenzettel)">

                                    </dx-autocomplete>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Gefahrgut-Verpackungsgruppe' | translate }}"
                                             [field]="fieldNames.scireumGefahrgutVerpackungsgruppe"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-autocomplete [minSearchLength]="0"
                                                     width="40%"
                                                     [dataSource]="gefahrgutVerpackungsgruppeArray"
                                                     [readOnly]="readOnlyForLinkedFields(fieldNames.scireumGefahrgutVerpackungsgruppe)"
                                                     [showClearButton]="showClearButton()"
                                                     [showDropDownButton]="true"
                                                     [(value)]="model.scireum.gefahrgutVerpackungsgruppe"
                                                     (onValueChanged)="update($event, fieldNames.scireumGefahrgutVerpackungsgruppe)">

                                    </dx-autocomplete>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Anzahl der Gefahrgut-Versandstücke' | translate }}"
                                             [field]="fieldNames.scireumAnzahlGefahrgutVersandstuecke"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">
                                    <dx-number-box [(value)]="model.scireum.anzahlGefahrgutVersandstuecke"
                                                   [min]="0"
                                                   width="30%"
                                                   placeholder=""
                                                   (onValueChanged)="update($event, fieldNames.scireumAnzahlGefahrgutVersandstuecke)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumAnzahlGefahrgutVersandstuecke)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-number-box>

                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Beschreibung der Gefahrgut-Versandstücke' | translate }}"
                                             [field]="fieldNames.scireumBeschreibungGefahrgutVerandstuecke"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-text-box [(value)]="model.scireum.beschreibungGefargutVersandstuecke"
                                                 width="80%"
                                                 (onValueChanged)="update($event, fieldNames.scireumBeschreibungGefahrgutVerandstuecke)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumBeschreibungGefahrgutVerandstuecke)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>

                        <div class="np-field">

                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Batteriepiktogramm' | translate }}"
                                             [field]="fieldNames.scireumBatteriepiktogramm"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-autocomplete [minSearchLength]="0"
                                                     [dataSource]="batteriepiktogrammAray"
                                                     [readOnly]="readOnlyForLinkedFields(fieldNames.scireumBatteriepiktogramm)"
                                                     [showClearButton]="showClearButton()"
                                                     [showDropDownButton]="true"
                                                     [(value)]="model.scireum.batteriepiktogramm"
                                                     width="40%"
                                                     (onValueChanged)="update($event, fieldNames.scireumBatteriepiktogramm)">

                                    </dx-autocomplete>
                                </div>
                            </np-inputControl>
                        </div>
                        <div class="np-field">
                            <np-inputControl [(model)]="model"
                                             [showLinkButtons]="true"
                                             [suppressPlaceLabel]="true"
                                             [(selectedElements)]="selectedElements"
                                             (elementSelected)="elementSelectFunction($event)"
                                             (onValueChanged)="update($event)"
                                             labelText="{{ 'Handelsname' | translate }}"
                                             [field]="fieldNames.scireumHandelsname"
                                             [showDragHandle]="showDragHandle"
                                             [dragFilter]="dragFilter"
                                             (excelElementDropped)="excelElementDrop($event)">
                                <div slot="content" class="contentSlot">

                                    <dx-text-box [(value)]="model.scireum.handelsname"
                                                 width="80%"
                                                 (onValueChanged)="update($event, fieldNames.scireumHandelsname)">
                                        <dx-validator validationGroup="SCIREUM"
                                                      (onInitialized)="validationService.startAutomaticValidation($event)">
                                            <dxi-validation-rule type="async"
                                                                 [validationCallback]="validationService.validateField(fieldNames.scireumHandelsname)"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </np-inputControl>
                        </div>
                    </div>
                </div>


            </div>
        </dxi-item>
    </dx-box>
</div>
